module.exports = __webpack_public_path__ + "img/DE00369.05bced67.png";